import { render, staticRenderFns } from "./addUserCredentials.vue?vue&type=template&id=2553f154&"
import script from "./addUserCredentials.vue?vue&type=script&lang=js&"
export * from "./addUserCredentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports